import { CheckoutState } from '../../state';
import { isCannedQuestion, isRequiredQuestion } from '../../utils/surveys';
import { getQuestionsForAttendees } from './attendees';
import { getQuestionsForBuyer } from './buyer';

export const hasRequiredCannedQuestions = (state: CheckoutState) => {
    const allQuestions = [
        ...getQuestionsForAttendees(state).flatMap(({ survey }) => survey),
        ...getQuestionsForBuyer(state),
    ];

    return allQuestions.some((question) => {
        return (
            isCannedQuestion(question) &&
            isRequiredQuestion(question, allQuestions)
        );
    });
};
